import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import {reaction, autorun} from 'mobx';
import Cookies from 'js-cookie';

@inject ('RootStore')
@observer class StateDropdown extends Component {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
    autorun(() => {
      const {RootStore} = this.props;
      let state = Cookies.get('voting_state');
      let stateName = Cookies.get('voting_stateName');
      if(state || stateName){
        RootStore.globalPropsStore.updateProp('wizardStateValue', state);
        RootStore.globalPropsStore.updateProp('wizardStateName', stateName);
      }
    });
  }

  changeValue =(e)=>{
    const {RootStore} = this.props;
    let {value} = e.target;
    let name = e.target.options[e.target.selectedIndex].text;
    if(Cookies.get('voting_state') || Cookies.get('voting_stateName')){
      Cookies.remove('voting_state');
      Cookies.remove('voting_stateName');
    }
    Cookies.set('voting_state', value, { expires: 7 });
    Cookies.set('voting_stateName', name, { expires: 7 });
    RootStore.globalPropsStore.updateProp('wizardStateValue', value);
    RootStore.globalPropsStore.updateProp('wizardStateName', name);
  }

  defaultValue =()=>{
    const {RootStore} = this.props;
    let state = Cookies.get('voting_state');
    if(!RootStore.globalPropsStore.wizardProps.wizardStateValue){
      if(state){
        return state;
      }else{
        return 'DEFAULT';
      }
    }else{
      return RootStore.globalPropsStore.wizardProps.wizardStateValue;
    }
  }

  render() {
    const {RootStore} = this.props;
    const {inline} = this.props
    return (
      <div>
        <select className={inline ? 'stateDropdown' : 'stateDropdown stateDropdown--inline'} onChange={this.changeValue} value={this.defaultValue()}>
          <option value="DEFAULT" disabled>Please select your state:</option>
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="DC">District Of Columbia</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="RI">Rhode Island</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
        </select>
      </div>
    );
  }

}

export default StateDropdown;
